export function safeInternalNext(next: string | null | undefined): string | null {
  if (!next) return null
  if (typeof next !== 'string') return null

  // Must be internal path
  if (!next.startsWith('/')) return null
  // Prevent protocol-relative URLs
  if (next.startsWith('//')) return null
  // Basic hardening against absolute URLs in query
  if (next.includes('://')) return null

  return next
}

